import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { clmApiClient } from '../clients';
import type {
  PatientSearchVerifyRequest,
  PatientSearchVerifyResponse,
} from '../types';

const patientSearchVerifyMutation = async (
  data: PatientSearchVerifyRequest,
): Promise<PatientSearchVerifyResponse> => {
  const response = await clmApiClient.post('patient/search/verify', data);

  if (!response.ok || !response.data) {
    throw new Error(response.problem ?? 'Error verifying patient search');
  }

  return response.data as PatientSearchVerifyResponse;
};

export const usePatientSearchVerifyMutation = (
  config?: Omit<
    UseMutationOptions<
      PatientSearchVerifyResponse,
      Error,
      PatientSearchVerifyRequest
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation({
    mutationKey: ['patient-search-verify'],
    mutationFn: patientSearchVerifyMutation,
    ...config,
  });
